module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/chart/stacked-bar-chart/stacked-bar-chart.component.less
// module id = ./src/app/shared/components/chart/stacked-bar-chart/stacked-bar-chart.component.less
// module chunks = main